/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var DemoBookedBy;

(function (DemoBookedBy) {
  DemoBookedBy["EMAIL"] = "email";
  DemoBookedBy["PHONE"] = "phone";
  DemoBookedBy["LINKEDIN"] = "linkedin";
  DemoBookedBy["BOOKING_LINK"] = "booking_link";
  DemoBookedBy["REFERRAL"] = "referral";
  DemoBookedBy["OTHER"] = "other";
})(DemoBookedBy || (DemoBookedBy = {}));